import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import NoImageFound from 'src/assets/NoImage.jpg';
import NoImageFoundFR from 'src/assets/NoImage_F.jpg';
import { TextField, Button, Icon, ImageContainer } from 'Components';
import './ProductListView.css';

const ProductListView = props => (
  <div className="product-list-view">
    <div className="product-list-view__details">
      <div>
        {!props.isCartSelected && props.isPinable && (
          <Button onClick={props.onStarClick}>
            <Icon icon={props.Pinned ? 'star' : 'star_border'} />
          </Button>
        )}
        <ImageContainer
          alt={props.PortalDescription}
          src={props.PortalPictureFileName}
          fallbackImage={i18n.language === 'E' ? NoImageFound : NoImageFoundFR}
        />
      </div>
      <div className="product-list-view__details__fields">
        <span>{props.PortalDescription}</span>
        <div>
          <span>{i18n.t('formsSupplies:Size')}:</span>
          <span>{props.Size}</span>
        </div>
        <div>
          <span>{i18n.t('formsSupplies:Type')}:</span>
          <span> {props.ItemType}</span>
        </div>
        <div>
          <span>{i18n.t('formsSupplies:Preservative')}:</span>
          <span>{props.Preservatives}</span>
        </div>
      </div>
    </div>
    <div className="product-list-view__buttons">
      {props.isCartSelected || !props.isInCart ? (
        <TextField
          onKeyPress={(e) => {
            if (e.key === 'Enter') e.preventDefault();
          }}
          placeholder={i18n.t('formsSupplies:Quantity')}
          type="number"
          value={props.quantity}
          onChange={props.onQuantityChange}
          hasError={props.hasQuantityError}
          isOnlyNumbers
        />
      ) : (
        <div className="product-grid-view__buttons__placeholder" />
      )}
      <Button className="button button--secondary" onClick={props.onSubmit}>
        {props.buttonText}
      </Button>
    </div>
  </div>
);

ProductListView.propTypes = {
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  buttonText: PropTypes.string,
  onStarClick: PropTypes.func,
  onQuantityChange: PropTypes.func,
  onSubmit: PropTypes.func,
  Pinned: PropTypes.bool,
  PortalDescription: PropTypes.string,
  PortalPictureFileName: PropTypes.string,
  Size: PropTypes.string,
  ItemType: PropTypes.string,
  Preservatives: PropTypes.string,
  isInCart: PropTypes.bool,
  isCartSelected: PropTypes.bool,
  hasQuantityError: PropTypes.string,
  isPinable: PropTypes.bool,
};

ProductListView.defaultProps = {
  Preservatives: 'Not Available',
  PortalDescription: '',
  PortalPictureFileName: NoImageFound,
};

export default ProductListView;



// WEBPACK FOOTER //
// ./src/components/ProductListView/ProductListView.jsx